/**
 * Capitalizes the first letter of the given string.
 * @param string - The string to capitalize.
 * @returns The string with the first letter capitalized.
 */
export function capitalizeFirstLetter(string: string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

/**
 * Converts a boolean string ('true' or 'false') to a boolean value.
 * @param val - The string to convert.
 * @returns The boolean value of the string, or false if the string is not 'true' or 'false'.
 */
export const grabBoolFromText = (val: string) => {
  if (val == 'false') return false;
  if (val == 'true') return true;
  return false;
};

/**
 * Converts a hex color code to an RGB object.
 * @param hex - The hex color code.
 * @returns An object with r, g, and b properties, or null if the hex code is invalid.
 */
export const hexToRgb = (hex: string) => {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
      }
    : null;
};

/**
 * Fixes Amazon S3 URLs by replacing specific prefixes with 'https://'.
 * @param url - The URL to fix.
 * @returns The fixed URL.
 */
export function fixAmazonS3Url(url: string) {
  const prefixArray = ['https://ambassador-api.s3.amazonaws.com/https%3A/', 'https://ambassador-api-dev.s3.amazonaws.com/https%3A/'];

  for (const prefix of prefixArray) {
    if (url.startsWith(prefix)) {
      return url.replace(prefix, 'https://');
    }
  }

  return url;
}

/**
 * Shortens the given text to the specified number of characters, adding '...' if truncated.
 * @param text - The text to shorten.
 * @param chars - The maximum number of characters.
 * @returns The shortened text.
 */
export const shortenText = (text: string | undefined, chars: number): string => {
  if (!text) return '';
  if (text?.length >= chars) return text?.substring(0, chars).concat('...');
  return text;
};
